import { timeline } from "@/mocks/home-data";
import SectionHeading from "./SectionHeading";

const toneDot: Record<string, string> = {
  起: "bg-secondary-500",
  锤: "bg-primary-500",
  转: "bg-accent-500",
  再转: "bg-accent-600",
  定: "bg-primary-700",
};

export default function MailuoModule() {
  return (
    <section id="mailuo" className="border-t border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker={timeline.kicker}
          title={timeline.title}
          desc="把一条大瓜拆成一段一条的事件脉络：几点起的火、哪一步实锤、反转又卡在哪，按序排好，来龙去脉一眼看到底。"
          right={
            <span className="inline-flex items-center gap-1.5 font-label text-xs font-medium text-foreground-500">
              <i className="ri-time-line text-primary-600" /> {timeline.meta}
            </span>
          }
        />

        <div className="relative mx-auto max-w-3xl">
          <div className="absolute bottom-2 left-[15px] top-2 w-px bg-background-200" />
          <div className="flex flex-col gap-6">
            {timeline.events.map((e, i) => (
              <div key={i} className="relative flex gap-5 pl-0">
                <div className="relative z-10 flex w-[30px] shrink-0 justify-center pt-1">
                  <span className={`h-4 w-4 rounded-full ring-4 ring-background-100 ${toneDot[e.tone] ?? "bg-secondary-500"}`} />
                </div>
                <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-2.5">
                      <span
                        className={`flex h-6 w-6 items-center justify-center rounded-md font-label text-[11px] font-bold text-background-50 ${toneDot[e.tone] ?? "bg-secondary-500"}`}
                      >
                        {e.tone}
                      </span>
                      <span className="font-label text-xs font-semibold text-foreground-500">{e.time}</span>
                    </div>
                    <span className="font-label text-[11px] text-secondary-600">{e.count}</span>
                  </div>
                  <h3 className="display-serif mt-3 text-lg font-bold text-foreground-950 md:text-xl">
                    {e.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{e.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}